import React, { useCallback, memo } from 'react';

import i18n from '../../i18n';

const LanguageMenu = ({ onClose }) => {
  const handleLanguageChange = useCallback(
    (lang) => {
      i18n.changeLanguage(lang);
      window.localStorage.setItem('LANG', lang);
      onClose();
    },
    [onClose],
  );

  return (
    <div className='localization-dropdown_menu'>
      <ul className='localization-dropdown_options'>
        <li className='localization-dropdown_item' role='presentation' onClick={() => handleLanguageChange('en')}>
          EN
        </li>
        <li className='localization-dropdown_item' role='presentation' onClick={() => handleLanguageChange('de')}>
          DE
        </li>
      </ul>
    </div>
  );
};

export default memo(LanguageMenu);
